<form #packagingForm="ngForm">
  <div class="mt-10 wm-form properties-tab">
    <div class="row form-group app-composite-widget clearfix">
      <label class="col-xs-3 pl-0">{{locale.LABEL_PREFAB_PROPS_DISPLAY_NAME}}</label>
      <input class="col-xs-6 form-control" name="display-name" placeholder="{{locale.PLACEHOLDER_ENTER_DISPLAY_NAME}}"
             [(ngModel)]="prefabConfig.displayName" [ngModelOptions]="{updateOn: 'change'}">
    </div>
    <div class="row form-group app-composite-widget clearfix">
      <label class="col-xs-3 pl-0">{{locale.LABEL_PROJECT_SETTINGS_PREFAB_ICON}}</label>
      <img class="prefab-icon" [src]="iconUrl">
      <i *ngIf="!isValidIcon" class="wms wms-error-outline" title="{{locale.LABEL_PROJECT_SETTINGS_PREFAB_ICON_SIZE_ERROR_MSG}}"></i>
      <div class="col-xs-6">
        <input name="file" type="file" id="icon-input" name="file" accept="image/*" class="wm-file-uploader prefab-icon-upload" (change)="prefabIconChange()">
        <label class="prefab-icon-help">{{locale.LABEL_PROJECT_SETTINGS_PREFAB_ICON_SIZE}}</label>
      </div>
    </div>
  </div>

</form>
